module.exports = __webpack_public_path__ + "static/media/phone-digit.cba17b83.svg";